<template>
  <a-card :bordered="false">
    <custom-dragging-table
      :columns="getTestColumns()"
      @draggable="onDraggableChange"
      :data-list="dataList"
    >
      <template slot="action" slot-scope="rowItem">
        <a @click="onTestEvent(rowItem.record)">提示按钮</a>
      </template>
    </custom-dragging-table>
  </a-card>

</template>

<script>
import CustomDraggingTable from '@/customComponents/CustomDraggingTable/CustomDraggingTable'

export default {
  name: 'TestDraggingTable',

  components: { CustomDraggingTable },
  data() {
    return {
      dataList: [
        { name: '测试1', id: 1, testName: 'test1' },
        { name: '测试2', id: 2, testName: 'test2' },
        { name: '测试3', id: 3, testName: 'test3' }
      ]
    }
  },
  mounted() {
  },
  methods: {
    getTestColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'id',
          width: '100px'
        },
        {
          title: '名字',
          dataIndex: 'name'
        },
        {
          title: '测试名字',
          dataIndex: 'testName'
        },
        {
          title: '操作',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },

    onTestEvent(record) {
      this.$message.success(record.name)
    },
    onDraggableChange(sortList) {
      console.error(sortList)
    }
  }

}
</script>
<style scoped>
</style>